<div *ngIf="show" 
     [class]="overlayClass"
     [class.spinner-blur]="blurBackground"
     [class.spinner-no-blur]="!blurBackground">
  
  <div [class]="contentClass" [class.spinner-content--bar]="variant === 'bar'">
    
    <!-- Spinner circular -->
    <ng-container *ngIf="variant === 'spinner'">
      <div class="spinner" 
           [style.width.px]="spinnerSize"
           [style.height.px]="spinnerSize"
           [style.border-width.px]="borderWidth"
           [style.border-color]="trackColor || null"
           [style.border-top-color]="color">
      </div>
      
      <!-- Texto (opcional) -->
      <p *ngIf="showText && text" class="spinner-text">
        {{ text }}
      </p>
    </ng-container>

    <!-- Barra de progreso -->
    <ng-container *ngIf="variant === 'bar'">
      <div class="spinner-bar" [class.spinner-bar--indeterminate]="barIndeterminate">
        <div class="spinner-bar__track" [style.background]="trackColor || null">
          <div class="spinner-bar__fill"
               [style.background]="color"
               [style.width.%]="barProgress !== null ? barProgress : 100"></div>
        </div>
        <p *ngIf="showText && barLabel" class="spinner-text">
          {{ barLabel }}
        </p>
        <p *ngIf="hint" class="spinner-hint">{{ hint }}</p>
      </div>
    </ng-container>
    
  </div>
  
</div>
